import { Card, CardContent } from '@ui/card.tsx';
import { Settings } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { PersonalInformationsForm } from '@client/components/forms/personal-informations-form.tsx';
import { UpdatePasswordForm } from '@r/components/user/forms/update-password-form.tsx';

export const PersonalInformations = () => {
  const { t } = useTranslation();

  return (
    <div className="overflow-x-hidden flex-grow">
      <div className="pl-8 flex flex-col h-full text-foreground">
        <div className="mb-10">
          <div className="flex flex-nowrap items-center mb-3">
            <Settings className="mr-3" />

            <h1 className="flex items-center font-bold text-2xl md:text-3xl lg:text-[2.75rem] lg:leading-[3.5rem]">
              {t('menu.account.personal.informations')}
            </h1>
          </div>

          <p className="font-light text-muted-foreground">
            {t('personal.information.description')}
          </p>
        </div>

        <Card className="w-full border-0">
          <CardContent className="p-7">
            <div className="mx-auto space-y-10 w-full 2xl:w-8/12">
              {/* Section Informations personnelles */}
              <div className="space-y-6">
                <div className="border-b-2 border-muted-foreground/40 pb-1.5 text-muted-foreground/80 font-medium">
                  {t('personal.information.title')}
                </div>
                <PersonalInformationsForm />
              </div>

              {/* Section Mot de passe */}
              <div className="space-y-6">
                <div className="border-b-2 border-muted-foreground/40 pb-1.5 text-muted-foreground/80 font-medium">
                  {t('personal.security.title')}
                </div>
                <UpdatePasswordForm variant="client" />
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
